//配置路由
import Vue from 'vue'
import VueRouter from 'vue-router'
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
//使用插件
Vue.use(VueRouter)
//引入路由组件
const Home = () => import('@/pages/home')
const Circle = () => import('@/pages/circle')
const CircleIntroduce = () => import('@/pages/circle/introduce')
const CircleIndex = () => import('@/pages/circle/circleIndex')
const CircleIndexSearch = () => import('@/pages/circle/circleIndexSearch')
const TalkPostList = () => import('@/pages/circle/talkPostList')
const CircleRank = () => import('@/pages/circle/rank')
const Detail = () => import('@/pages/circle/detail')
const questionDetail = () => import('@/pages/circle/questionDetail')
const userIndex = () => import('@/pages/userCenter/userIndex')
const Competition = () => import('@/pages/competition')
const Introduction = () => import('@/pages/competition/introduction')
const Video = () => import('@/pages/competition/video')
const Time = () => import('@/pages/competition/time')
const Prize = () => import('@/pages/competition/prize')
const Expert = () => import('@/pages/competition/expert')
const CompetitionIndex = () => import('@/pages/competition/competitionIndex')
const Message = () => import('@/pages/userCenter/message')
const Public = () => import('@/pages/userCenter/public')
const PublicIndex = () => import('@/pages/userCenter/public/publicIndex')
const PublicManage = () => import('@/pages/userCenter/public/publicManage')
const UserInfo = () => import('@/pages/userCenter/public/userInfo')
const PointsDetails = () => import('@/pages/userCenter/public/pointsDetails')
const MyCollection = () => import('@/pages/userCenter/public/myCollection')
const Login = () => import('@/pages/login')
const Activity = () => import('@/pages/activity')
const ActivityDetail = () => import('@/pages/activity/detail')
const CommentReply = () => import('@/pages/userCenter/message/commentReply')
const SystemMessage = () => import('@/pages/userCenter/message/systemMessage')
const LikeFllow = () => import('@/pages/userCenter/message/likeFllow')
const Product = () => import('@/pages/product')
const Document = () => import('@/pages/product/document')
const Download = () => import('@/pages/product/download')
const News = () => import('@/pages/product/news')
const CaseInfo = () => import('@/pages/product/caseInfo')
const ProductIndex = () => import('@/pages/product/productIndex')
const SingleDocument = () => import('@/pages/product/singleDocument')
const SinglePage = () => import('@/pages/product/singlePage')
const ProductVideo = () => import('@/pages/product/video')
const NewsDetail = () => import('@/pages/product/news/newsDetail')
const VideoDetail = () => import('@/pages/product/video/videoDetail')
const Search = () => import('@/pages/product/search')
const RankRules = () => import('@/pages/circle/rankRules')
// const ProductTemplate = () => import('@/pages/product/template')
const ProductTemplate = () => import('@/pages/product/template/indexNew')
const ApplyTry = () => import('@/pages/product/template/applyTry')
const UserInfoCirclList = () => import('@/pages/userCenter/listInfo/userInfoCirclList')
const UserInfofollowList = () => import('@/pages/userCenter/listInfo/userInfofollowList')
const UserInfoFansList = () => import('@/pages/userCenter/listInfo/userInfoFansList')

//配置路由
const routes = [{
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        component: Home,
        meta: {
            isShowHeader: true,
            title: '麒麟软件',
            isFull: true
        }
    },
    {
        path: '/circle',
        component: Circle,
        meta: {
            isShowHeader: true,
            title: '圈子'
        }
    },
    {
        path: '/circleIntroduce',
        component: CircleIntroduce,
        meta: {
            isShowHeader: true,
            title: '圈子介绍'
        }
    },
    {
        path: '/circleIndex',
        component: CircleIndex,
        meta: {
            isShowHeader: true
        }
    },
    {
        path: '/circleIndexSearch',
        component: CircleIndexSearch,
        meta: {
            isShowHeader: true
        }
    },
    {
        path: '/talkPostList',
        component: TalkPostList,
        meta: {
            isShowHeader: true
        }
    },
    {
        path: '/circleRank',
        component: CircleRank,
        meta: {
            isShowHeader: true
        }
    },
    {
        path: '/rankRules',
        component: RankRules,
        meta: {
            isShowHeader: true
        }
    },
    {
        path: '/detail',
        component: Detail,
        meta: {
            isShowHeader: true
        }
    },
    {
        path: '/questionDetail',
        component: questionDetail,
        meta: {
            isShowHeader: true
        }
    },
    {
        path: '/userIndex',
        component: userIndex,
        meta: {
            isShowHeader: true
        }
    },
    {
        path: '/competition',
        component: Competition,
        meta: {
            isShowHeader: true,
            title: '大赛专区'
        }
    },
    {
        path: '/UserInfoCirclList',
        component: UserInfoCirclList,
        meta: {
            isShowHeader: true,
            title: '圈子列表'
        }
    },
    {
        path: '/UserInfofollowList',
        component: UserInfofollowList,
        meta: {
            isShowHeader: true,
            title: '关注列表'
        }
    },
    {
        path: '/UserInfoFansList',
        component: UserInfoFansList,
        meta: {
            isShowHeader: true,
            title: '粉丝列表'
        }
    },
    {
        path: '/competitionIndex',
        component: CompetitionIndex,
        redirect: '/introduction',
        meta: {
            isShowHeader: true
        },
        children: [{
                path: '/introduction',
                component: Introduction,
                meta: {
                    isShowHeader: true
                }
            },
            {
                path: '/comVideo',
                component: Video,
                meta: {
                    isShowHeader: true
                }
            },
            {
                path: '/prize',
                component: Prize,
                meta: {
                    isShowHeader: true
                }
            },
            {
                path: '/time',
                component: Time,
                meta: {
                    isShowHeader: true
                }
            },
            {
                path: '/expert',
                component: Expert,
                meta: {
                    isShowHeader: true
                }
            }
        ]
    },
    {
        path: '/message',
        component: Message,
        redirect: '/commentReply',
        meta: {
            isShowHeader: true,
            isLogin: true
        },
        children: [{
                path: '/commentReply',
                component: CommentReply,
                meta: {
                    isShowHeader: true
                }
            },
            {
                path: '/systemMessage',
                component: SystemMessage,
                meta: {
                    isShowHeader: true
                }
            },
            {
                path: '/likeFllow',
                component: LikeFllow,
                meta: {
                    isShowHeader: true
                }
            }
        ]
    },
    {
        path: '/public',
        component: Public,
        redirect: '/publicIndex',
        meta: {
            isShowHeader: true,
            isLogin: false
        },
        children: [{
                path: '/publicIndex',
                component: PublicIndex,
                meta: {
                    isShowHeader: true
                }
            },
            {
                path: '/publicManage',
                component: PublicManage,
                meta: {
                    isShowHeader: true
                }
            },
            {
                path: '/userInfo',
                component: UserInfo,
                meta: {
                    isShowHeader: true
                }
            },
            {
                path: '/pointsDetails',
                component: PointsDetails,
                meta: {
                    isShowHeader: true
                }
            },
            {
                path: '/myCollection',
                component: MyCollection,
                meta: {
                    isShowHeader: true,
                    isLogin: true
                }
            }
        ]
    },
    
    {
        path: '/login',
        component: Login,
        meta: {
            isShowHeader: true,
            title: '登录'
        }
    },
    {
        path: '/auth/callback',
        component: Login,
        meta: {
            isShowHeader: false,
            title: '登录回调'
        }
    },
    {
        path: '/activity',
        component: Activity,
        meta: {
            isShowHeader: true,
            title: '活动专区'
        }
    },
    {
        path: '/activityDetail',
        component: ActivityDetail,
        meta: {
            isShowHeader: true,
            title: '活动详情'
        }
    },

    // {
    // 	path: '/error',
    // 	component: Error,
    // 	meta: {
    // 	    isShowNav: false,
    // 	    isShowHeader: false,
    // 		isShowFooter: false
    // 	}
    // }
]
const router = new VueRouter({
    routes: routes,
    mode: 'history'
    // mode:'hash'
})
//beforeEach每次进行路由跳转时都会执行
router.beforeEach((to, from, next) => {
    if (to.matched.length === 0) {
        next('/error')
    } else {
        if (to.meta.title) {
            document.title = to.meta.title
        }
        if (to.matched.some(rec => rec.meta.isLogin)) {
            if (localStorage.getItem('userId')) {
                next()
            } else {
                next('/login')
            }
        } else {
            next()
        }
    }
})
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)

});
export default router